import React from 'react'

export default function Banner() {
  return (
  <div id="banner" className="container-fluid">
  <section id="banText">
        <h1 className="h-primary container">News Upon</h1>
        <p className='container'>We as a Team-“NewsUpon” is committed to proving first class News through setting quality objectives and
            targets in all areas of our operation including quality Reporting and delivery of every importanat News
            with the aim of continually improving our service performance, which is regularly monitored and measured by
            management to deliver improved customer services.
        </p>
        <h4 className="h-primary container">ThankYou</h4>
    </section>
  </div>
  
  )
}
